import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActionMenuEvent, ActionMenuItem } from '../actionmenu/action-menu.component';
import { DataTableRow } from '../datatable/datatable.component';

@Component({
    selector: 'app-databulkaction',
    templateUrl: './databulkaction.component.html',
    styleUrls: ['./databulkaction.component.css'],
    standalone: false
})
export class DatabulkactionComponent implements OnInit, OnChanges {

  @ViewChild("self") self: ElementRef;

  supportedActions: ActionMenuItem[] = [];
  @Input() count: number = 0;
  @Input() rows: DataTableRow[] = [];

  @Output() actionmenuevent: EventEmitter<ActionMenuEvent> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setSupportedActions();
  }

  setSupportedActions(): void {
    this.supportedActions = [];
    if (this.rows != undefined) {
      this.rows.forEach((row) => {
        if (row.selected && row.actions) {
          row.actions.forEach((action) => {
            if (this.count == 1 && (!row.disableCheckbox || action.isPersistent)) {
              this.supportedActions.push(action);
            }

            if (this.count > 1 && action.bulk && (!row.disableCheckbox || action.isPersistent) && !this.isActionSupported(action.id)) {
              this.supportedActions.push(action);
            }
          });
        }
      });
    }
  }

  isActionSupported(id: string): boolean {
    var isSupported: boolean = false;
    this.supportedActions.forEach((action) => {
      if (action.id === id) {
        isSupported = true;
        return;
      }
    });
    return isSupported;
  }

  isRowActionSupported(row:DataTableRow):boolean{
    let isSupported: boolean = false;

    for(let i = 0; i < row.actions.length; i++) {
      if(this.isActionSupported(row.actions[i].id)){
        isSupported = true;
        break;
      }
    }

    return isSupported;
  }

  bulkMenuActionClicked(actionItem: ActionMenuItem): void {
    var selected: any[] = [];
    let lastIndex:number = 0;

    if(actionItem.enabled){
      actionItem.enabled = false;
      this.rows.forEach((row, index) => {
        //row is selected and supports the action menu
        if (row.selected && this.isRowActionSupported(row)) {
          selected.push(row.data);
          lastIndex = index;
        }
      });
      this.actionmenuevent.emit(new ActionMenuEvent(actionItem.id, selected, selected.length == 1 ? lastIndex : 0));
      //the action menu is event driven, we disable the button briefly to avoid multiple dialogs or other issues from double clicks
      setTimeout(() => {
        actionItem.enabled = true;
      }, 1000);
    }
  }

  bulkMenuActionKeyDown(event: KeyboardEvent, actionItem: ActionMenuItem): void {
    let currentElement: HTMLElement = (event.target as HTMLElement);
    if (event.key == "Enter") {
      event.preventDefault();
      this.bulkMenuActionClicked(actionItem);
    } else if (event.key == "ArrowRight" || event.key == "ArrowLeft") {
      if (event.key == "ArrowRight" && currentElement.nextElementSibling) {
        (currentElement.nextElementSibling as HTMLElement).focus();
      } else if (event.key == "ArrowLeft" && currentElement.previousElementSibling) {
        (currentElement.previousElementSibling as HTMLElement).focus();
      }
    } else if (event.key == "Home" || event.key == "End") {
      let actionElements: HTMLCollectionOf<any> = currentElement.parentElement.getElementsByClassName("bulk-action-item");
      actionElements[event.key == "Home" ? 0 : actionElements.length - 1].focus();
    }
  }

}
